module.exports = __webpack_public_path__ + "static/img/oppo.197486e1.png";